import dayjs from 'dayjs';

// eslint-disable-next-line import/prefer-default-export
export class DateFormatter {
  static formatDate(dateRange) {
    return `${dayjs(dateRange.date).format('YYYY-MM-DD')}T${dayjs(dateRange.time).format('HH:mm:ss')}`;
  }
}
